import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import prefixPath from "../utils/prefixPath";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;
  prefixPathApis = undefined;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
    this.prefixPathApis = new prefixPath(apiEndpoint);
  }

  searchAllianceUser(condition, allianceID) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/searchUser`;
    return httpPost(apiUrl, condition);
  }

  getAllianceUserList(allianceID) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/user/list`;
    return httpGet(apiUrl);
  }

  getAllianceBulkUser(allianceID, userIDs) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/user/bulkread`;
    return httpPost(apiUrl, { userIDs });
  }

  getAllianceUser(allianceID, userID) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/get/user?userID=${userID}`;
    return httpGet(apiUrl);
  }

  getAlliancePet(allianceID, petID) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/get/pet?petID=${petID}`;
    return httpGet(apiUrl);
  }

  getAlliancePetsByUser(userData) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${userData.alliance}/${clinicID}/getUserPets`;
    return httpPost(apiUrl, userData);
  }

  async getAllianceRecordListByPet(allianceID, petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/getRecordListByPet`;

    let res = await httpPost(apiUrl, { petID });
    if (res.code === 100000 && res.result)
      this.prefixPathApis.prependRecordResourcePath(res.result, clinicID);
    return res;
  }

  getAllianceInHospitalExamByPetVer2(allianceID, petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/inHospital/v2/exam/pet?petID=${petID}`;
    return httpGet(apiUrl);
  }

  getAllianceInHospitalListByPetVer2(allianceID, petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/inHospital/v2/explore/pet?petID=${petID}`;
    return httpGet(apiUrl);
  }

  getAllianceExamDeviceByPetID(allianceID, petID, attachType, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/exam/device/petID?petID=${petID}&attachType=${attachType}`;
    return httpGet(apiUrl);
  }

  getAllianceReferralList(allianceID, petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/referral/list?petID=${petID}`;
    return httpGet(apiUrl);
  }

  getAllianceBookingList(allianceID, options, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/booking/explore`;
    return httpPost(apiUrl, options);
  }

  getAllianceClinics(allianceID) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/alliance/${allianceID}/${clinicID}/setting/clinics`;
    return httpGet(apiUrl);
  }

  getAllianceDeposit(allianceID, userID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/alliance/${allianceID}/${clinicID}/deposit/${Crypto.encrypt(
      userID,
      CryptoKey
    )}`;
    return httpGet(apiUrl);
  }

  getAllianceUndoneBillings(allianceID, userID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/alliance/${allianceID}/${clinicID}/undoneBilling/user/${Crypto.encrypt(
      userID,
      CryptoKey
    )}`;
    return httpGet(apiUrl);
  }

  // getAllianceUndoneBillingsByPetID(allianceID, userID, clinic) {
  //   let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
  //   let apiUrl = `${
  //     this.apiEndpoint
  //   }/api/sdk/v2/alliance/${allianceID}/${clinicID}/deposit/${Crypto.encrypt(
  //     userID,
  //     CryptoKey
  //   )}`;
  //   return httpGet(apiUrl);
  // }
}
